<div *ngIf="form" class="tableForm {{layoutModifier}}">
  <div class="tableForm-headerActions" *ngIf="showHeaderActions">
    <app-input-search [layoutMod]="inputSearchLayoutMod" [placeholderTranslationKeys]="config.searchTranslationKeys"
      (onSearch)="searchData($event)">
    </app-input-search>

    <ng-container *ngIf="form && filtersForm && dropdownFilters.length">
      <app-dropdown *ngFor="let d of dropdownFilters" [mainForm]="filtersForm" [controlName]="d.controlName"
        [options]="d.options" [labelKey]="d.labelKey" [valueKey]="d.valueKey">
      </app-dropdown>
    </ng-container>

    <ng-content></ng-content>
  </div>

  <app-table class="tableForm-table" [data]="data" [columnDefs]="config.columnDefs" [sortKey]="sortKey"
    [sortDirection]="sortDirection" [displayedColumns]="displayedColumns" [rowDef]="config.rowDef || {}"
    (rowSelected)="onRowSelect($event)" (onSort)="sortBy($event)">

    <ng-container *ngIf="layoutMod === 'wide'" cdkColumnDef="checkmark">
      <th cdk-header-cell *cdkHeaderCellDef></th>
      <td cdk-cell *cdkCellDef="let row" class="tableForm-checkmark">
        <label class="preselectedRow-container">
          <input type="radio" name="'rowSelect'" [value]="row" [checked]="row === selectedRow">
          <span class="preselectedRow-checkmark"></span>
        </label>
      </td>
    </ng-container>

    <ng-container *ngIf="layoutMod === 'narrow'" cdkColumnDef="actions">
      <th cdk-header-cell *cdkHeaderCellDef></th>
      <td cdk-cell *cdkCellDef="let row" class="tableForm-actions">
        <ng-container *ngIf="(config.getCustomActionsData && config.getCustomActionsData(row)) as customData; else action">
          <div class="actions-btns-container">
            <app-button-dropdown *ngIf="row.status !== 'INVITED'" [disabled]="!row.canEdit" [ngClass]="{'actions-container': !customData.label }"
              [layoutMod]="customData.label ? 'label' : 'table'" [buttonText]="customData.label"
              [items]="customData.actions" (itemSelected)="onActionSelect($event, row)">
            </app-button-dropdown>
            <div *ngIf="row.status === 'INVITED'" class="label" type="submit" [ngClass]="{'actions-container': !customData.label }">
              {{customData.label | translate}}
            </div>
            <button *ngIf="row.status === 'INVITED'" class="btn btn_primary btn_sm resend-invitation-btn" type="submit" [ngClass]="{'actions-container': !customData.label }" (click)="inviteAgain(row)">
              {{'SETTINGS.TEAM.INVITE_AGAIN'| translate}}
            </button>
          </div>
        </ng-container>
        <ng-template #action>
          <app-button-dropdown *ngIf="config.getActionsFilteredByRow" class="actions-container" [layoutMod]="'table'"
            (itemSelected)="onActionSelect($event, row)"
            [items]="config.getActionsFilteredByRow(row, config.actions ? config.actions : [])">
          </app-button-dropdown>
          <app-button-dropdown *ngIf="!config.getActionsFilteredByRow" class="actions-container" [layoutMod]="'table'"
            (itemSelected)="onActionSelect($event, row)" [items]="config.actions">
          </app-button-dropdown>
        </ng-template>
      </td>
    </ng-container>

  </app-table>

  <ng-container *ngIf="data && !data.length; else pagination">
    <app-table-no-results></app-table-no-results>
  </ng-container>

  <ng-template #pagination>
    <app-table-pagination *ngIf="showPagination" [form]="form" [controlName]="'itemsPerPage'"
      [isPrevPageDisabled]="isPrevPageDisabled" [isNextPageDisabled]="isNextPageDisabled" (onNextPage)="nextPage()"
      (onPreviousPage)="previousPage()">
    </app-table-pagination>
  </ng-template>

</div>
